<template>

<app-input-wrapper :note="note" :label="label" :errored="errored" class="scale">

	<div class="scale-options">

		<div class="scale-options-item" v-for="number in max" :key="number" :class="{'is-active': number === value}" v-on:click="onOptionClick(number)">{{ number }}</div>

	</div>

</app-input-wrapper>

</template>

<script>

import mixinInput from '@/mixin/input.js'

export default {

	mixins: [mixinInput],

	props: ['max'],

	methods: {

		onOptionClick: function(value) {

			this.onValueChange(value)

		}

	}

}

</script>

<style scoped>

.scale >>> .input-content-label {
    width: auto;
    flex-grow: 1;
}

.scale >>> .input-content-input {
    width: auto;
    flex-grow: 0;
}

.scale-options {
	display: flex;
    flex-direction: row;
    height: 40px;
}

.is-desktop .scale-options:hover .scale-options-item:not(.is-active) {
	border-color: var(--color-grey-highlight);
}

.is-desktop .scale.is-errored .scale-options:hover .scale-options-item:not(.is-active) {
    border-color: var(--color-red-dark);
}

.scale-options-item {
	font-size: 14px;
	line-height: 40px;
	padding: 0px 10px;
    min-width: 40px;
    text-align: center;
	color: var(--color-grey-dark);
	font-weight: 300;
	cursor: pointer;
    transition: all 100ms linear;
	border: 1px solid var(--color-grey-light);
    border-left-width: 0px;
}

.scale.is-errored .scale-options-item:not(.is-active) {
    border-color: var(--color-red-light);
}

.scale-options-item:first-child {
    border-left-width: 1px;
    border-radius: 4px 0px 0px 4px;
}

.scale-options-item:last-child {
    border-radius: 0px 4px 4px 0px;
}

.is-desktop .scale-options-item:hover {
	background-color: var(--color-grey-light);
}

.scale-options-item.is-active {
    background-color:var(--color-blue-light);
    border-color:var(--color-blue-light);
    color: #fff;
	font-weight: 700;
}

.scale-options-item.is-active:hover {
    background-color:var(--color-blue-dark);
	border-color: var(--color-blue-dark);
}

</style>